import DeactivatePageContainer from "./Containers/DeactivatePageContainer";
export default DeactivatePageContainer;
